import Nav from "../components/Nav";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import PageShell from "../components/marketing/PageShell";
import PageHero from "../components/marketing/PageHero";
import CTAStrip from "../components/marketing/CTAStrip";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export default function CoachesPage() {
  return (
    <PageShell testid="page-coaches">
      <SEO
        title="For Coaches"
        description="Coach on BRep — a live marketplace for qualified coaches. Every coach is checked before being approved. Apply now."
        path="/coaches"
      />
      <Nav />
      <PageHero
        eyebrow="For Coaches"
        title="Coach for"
        titleAccent="BRep."
        subtitle="A live marketplace for qualified coaches. Take on clients on your terms, keep your independence, get paid per service."
      />

      {/* Temporary placeholder block — replaces the previous fake coach profiles. */}
      <section className="px-6 md:px-12 py-20 md:py-32" data-testid="coaches-placeholder">
        <div className="max-w-4xl mx-auto text-center md:text-left">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="font-anton uppercase text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tight"
          >
            Qualified Coaches.{" "}
            <span className="text-[#2A5BFF]">Real Expertise.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-6 text-white/70 text-lg md:text-xl font-light leading-relaxed max-w-2xl mx-auto md:mx-0"
          >
            Every BRep coach is checked before being approved to provide services through the platform.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="mt-10 flex justify-center md:justify-start"
          >
            <Link
              to="/contact"
              className="btn-primary group inline-flex items-center gap-3 px-6 py-4 text-[12px] tracking-[0.22em] uppercase font-medium"
              data-testid="coaches-become-a-coach"
            >
              Become a Coach
              <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </motion.div>
        </div>
      </section>

      <CTAStrip
        eyebrow="Get Started"
        title="Ready to book?"
        subtitle="Browse the service catalogue or download the app."
        primary={{ to: "/services", label: "View Services" }}
        secondary={{ to: "/download", label: "Download App" }}
      />
      <Footer />
    </PageShell>
  );
}
